import React from 'react';

interface GuestPreviewStatCardProps {
  label: string;
  value: string;
}

export const GuestPreviewStatCard: React.FC<GuestPreviewStatCardProps> = ({
  label,
  value,
}) => {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white px-4 py-3">
      <p className="text-xs text-gray-500">{label}</p>
      <p className="mt-1 text-xl font-bold text-gray-900">{value}</p>
    </div>
  );
};
